import { AuthApi, CandidateApi, Configuration, DashboardApi, DomainApi, JobsApi } from "../swagger";

const config = new Configuration({
  basePath: '/api',
  fetchApi: fetch,
});

export const domainApi = new DomainApi(config);
export const adminJobApi = new JobsApi(config)
export const adminDashboardApi = new DashboardApi(config)
export const candidateApi = new CandidateApi(config)
export const authApi = new AuthApi(config)